import React, { useEffect, useState } from "react";

import s from './SchoolDetail.module.css';
import SchoolConfig from './SchoolConfig';
import SchoolClass from './SchoolClass';
import SchoolGroup from './SchoolGroup';
import SchoolStudents from './SchoolStudents';
import SchoolTeachers from './SchoolTeachers';
import SchoolItem from './SchoolItem';
import SchoolGroupTokenUsage from './SchoolGroupTokenUsage';
import { getData, postData} from '../middleware/apiMiddleware';
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import { getGeneralStorage, setGeneralStorage} from '../middleware/dataStorage';
import {RedButton, GreenButton, BlueButton} from './MyButton';
import MyTooltip from '../components/Utilities/MyTooltip';



export default function SchoolDetail(prop) {
	const navigate = useNavigate();
	const [toggleTag, setToggleTag] = useState((getGeneralStorage('schoolDetailToggle') ?? "config"));
	const [name, setName] = useState();
	const [eduLv, setEduLv] = useState();
	const [currentYearRange, setCurrentYearRange] = useState();
	const [isEnabled, setIsEnabled] = useState(false);
	let schoolId = prop.schoolId;
	
	const processToggleTag = (toggle) =>{
		setGeneralStorage('schoolDetailToggle', toggle);
		setToggleTag(toggle)
	}
	
	const fetchData = async () => {
		let res = await getData('schoolApi/schoolBasic?orgId=' + schoolId, navigate);
		setName(res.data['name']);
		setEduLv(res.data['eduLv']);
		setCurrentYearRange(res.data['currentYearRange']);
		setIsEnabled(res.data['isEnabled']);
	}
	
	useEffect(() => {
		fetchData();
	}, []);

	return (<div className={s.schoolDetailMain} style={{position:"relative"}}>
		<div style={{display:"flex", alignItems:"center", gap:"10px"}}>
			<div style={{fontSize:"1.5rem", textAlign:"left", fontWeight:"bold", 
				background:((!isEnabled)?"#be380e":""), 
				color:((!isEnabled)?"white":"")}}>{name}</div>
		
			<MyTooltip msg={"&lt;page&gt;" +
											"school.js<br/><br/>" +
											"&lt;components&gt;<br/>" +
											"SchoolDetail.js<br/>" +
											"SchoolCreateUsers.js<br/>" +
											"SchoolConfig.js<br/>" +
											"SchoolClass.js<br/>" +
											"SchoolTeachers.js<br/>" +
											"SchoolStudents.js<br/>" +
											"SchoolItem.js<br/>" +
											"SchoolGroup.js<br/>" +
											"SchoolGroupTokenUsage.js<br/>"} /> 
			
		</div>
		<div className={s.optionToggleHolder}>
			<div className={s.optionToggle} style={(toggleTag=="config")?{background:"#808080", color:"white"} : {cursor:"pointer"}} onClick={()=>processToggleTag("config")}>Config</div>
			<div className={s.optionToggle} style={(toggleTag=="class")?{background:"#808080", color:"white"} : {cursor:"pointer"}} onClick={()=>processToggleTag("class")}>Class</div>
			<div className={s.optionToggle} style={(toggleTag=="teacher")?{background:"#808080", color:"white"} : {cursor:"pointer"}} onClick={()=>processToggleTag("teacher")}>Teacher</div>
			<div className={s.optionToggle} style={(toggleTag=="student")?{background:"#808080", color:"white"} : {cursor:"pointer"}} onClick={()=>processToggleTag("student")}>Student</div>
			<div className={s.optionToggle} style={(toggleTag=="grouper")?{background:"#808080", color:"white"} : {cursor:"pointer"}} onClick={()=>processToggleTag("grouper")}>Grouper</div>
			<div className={s.optionToggle} style={(toggleTag=="item")?{background:"#808080", color:"white"} : {cursor:"pointer"}} onClick={()=>processToggleTag("item")}>Item</div>
			<div className={s.optionToggle} style={(toggleTag=="analysis")?{background:"#808080", color:"white"} : {cursor:"pointer"}} onClick={()=>processToggleTag("analysis")}>Analysis</div>
		</div>
		
		<div>
			{
				(toggleTag=="config") && (<SchoolConfig schoolId={schoolId} eduLv={eduLv} currentYearRange={currentYearRange}/>)
			}
			{
				(toggleTag=="class") && (<SchoolClass schoolId={schoolId} eduLv={eduLv} currentYearRange={currentYearRange}/>)
			}
			{
				(toggleTag=="teacher") && (<SchoolTeachers schoolId={schoolId} eduLv={eduLv} currentYearRange={currentYearRange}/>)
			}
			{
				(toggleTag=="student") && (<SchoolStudents schoolId={schoolId} eduLv={eduLv} currentYearRange={currentYearRange}/>)
			}
			{
				(toggleTag=="grouper") && (<SchoolGroup schoolId={schoolId} />)
			}
			{
				(toggleTag=="item") && (<SchoolItem schoolId={schoolId} />)
			}
			{
				(toggleTag=="analysis") && (<div>
					<SchoolGroupTokenUsage orgId={schoolId} />
				
				</div>)
			}
		</div>
	</div>);
}